import React from 'react';
import { Field } from 'react-final-form';
import styled from 'styled-components';

import { usePluralization } from 'common/hooks';
import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import { Typography } from 'common/typography';

import CustomRadioCard from '../CustomRadioCard';

type DiscountedItemCountInputProps = {
  name: string;
  defaultValue: number;
  enabledCounts?: number[];
  disabled: boolean;
  messageId: string;
  onChange?: (value: number) => void;
};

const RadioGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 8px;
  margin-block-start: 4px;

  @media (width < 1200px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (width < ${MOBILE_BREAKPOINT}px) {
    grid-template-columns: 1fr;
  }
`;

export const DISCOUNTED_ITEM_COUNT_OPTIONS = [1, 2, 3, 4];

export const DiscountedItemCountInput = ({
  name,
  defaultValue,
  enabledCounts,
  disabled,
  messageId,
  onChange,
}: DiscountedItemCountInputProps) => {
  const { FormattedPluralMessage } = usePluralization();

  return (
    <RadioGroup>
      {DISCOUNTED_ITEM_COUNT_OPTIONS.map(option => (
        <Field<number> name={name} type="radio" value={option} key={option} defaultValue={defaultValue}>
          {({ input }) => (
            <CustomRadioCard
              {...input}
              onChange={() => {
                input.onChange(input.value);
                onChange?.(input.value);
              }}
              inputProps={{
                disabled: disabled || enabledCounts?.includes(option) === false,
              }}
            >
              <Typography.Body3>
                <FormattedPluralMessage id={messageId} count={Number(option)} />
              </Typography.Body3>
            </CustomRadioCard>
          )}
        </Field>
      ))}
    </RadioGroup>
  );
};
